module.exports = __webpack_public_path__ + "static/media/umbrella-sky-blue.47186dc3.svg";